import React, {useEffect} from 'react';
import {Title, TitleLevel, TitleSize, TitleColor} from 'components/ui/Title';
import Container from 'components/layout/Container';
import {DOCUMENT_NAMES} from 'data/document';
import useAnalyticEvent from 'hooks/useAnalyticsEveent';

import './DocumentsPage.scss';

function DocumentsPage() {
  useAnalyticEvent('quick_view', {});
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="documents-page">
      <Container>
        <Title
          extraClassName="documents-page__title"
          level={TitleLevel.H4}
          size={TitleSize.H3}
          color={TitleColor.black}
        >
          Документы входящие в&nbsp;проект ремонта
        </Title>

        <ul className="documents-page__documents-list">
          {DOCUMENT_NAMES.map(documentName => (
            <li className="documents-page__document" key={documentName}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="none"
              >
                <circle cx="8" cy="8" r="8" fill="#00F" />
                <path
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m5 8 2 2 4-4"
                />
              </svg>
              {documentName}
            </li>
          ))}
        </ul>
      </Container>
    </main>
  );
}

export default DocumentsPage;
